import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import MainHeader from "../../components/MainHeader";

import logo from "../../assets/homeTriangle/oxeTechLabLogoON.png";

import Turmas from "../../components/TurmasOxetechLab";
import Card from "../../components/VagasOxetechLab";
import "./styles.css";
import { createTheme } from "@mui/material";
import { useAuth } from "../../hooks/auth/AuthContext";
import { Container, Logo, TabsCursos } from "./styles";
import { NavLink } from "react-router-dom";
import api from "../../services/api";
import { parseISO, addDays, isAfter, isSameDay, format } from "date-fns";
import { IoLogoFacebook } from "react-icons/io";
import { FaXTwitter, FaInstagram } from "react-icons/fa6";
import logoOxetech from "../../assets/logo_oxe-tech.png";

const theme = createTheme({
  palette: {
    primary: {
      main: "#D46D0D",
    },
  },
});

function OxetechLabDivulgacao() {
  const signed = useSelector((state) => state.auth.signed);
  const { adminUser } = useAuth();
  const [turmas, setTurmas] = useState([]);
  const tabs = [
    {
      label: "Turmas Disponíveis",
      componente: <Card className="card" />,
    },
    {
      label: "Minhas Turmas",
      componente: <Turmas className="card" />,
    },
  ];

  useEffect(() => {
    api
      .get("turma/disponiveis-private")
      .then(async (response) => {
        const turmasData = response.data.filter((turma) => {
          const encerramentoInscricoes = parseISO(
            turma.data_encerramento_inscricoes
          );
          const dataAtual = new Date();
          return (
            isAfter(encerramentoInscricoes, dataAtual) ||
            isSameDay(encerramentoInscricoes, dataAtual)
          );
        });

        const turmasComInstrutores = await Promise.all(
          turmasData.map(async (turma) => {
            try {
              const res = await api.get(
                `/instrutor/by-turma?turmaId=${turma.id}`
              );
              return { ...turma, instrutor: res.data };
            } catch (error) {
              console.log("Erro ao buscar instrutor:", error);
              return { ...turma, instrutor: null };
            }
          })
        );
        setTurmas(turmasComInstrutores);
      })
      .catch((err) => {
        console.log(err.response.data.error);
      });
  });

  const converteData = (data) => {
    const dataParse = parseISO(data);
    const dataFormatada = format(dataParse, "dd/MM/yyyy");
    return dataFormatada;
  };

  const [professor, setProfessor] = useState(false);
  const toggleProfessor = () => setProfessor(!professor);

  const courses = [
    {
      curso: "Lógica de Programação",
      local: "Maceió - Alagoas",
      cargaHoraria: "40 hrs",
    },
    {
      curso: "Desenvolvimento com Goolang",
      local: "Maceió - Alagoas",
      cargaHoraria: "40 hrs",
    },
    {
      curso: "Gestão de mídias sociais",
      local: "Batalha - Alagoas",
      cargaHoraria: "40 hrs",
    },
    {
      curso: "Informática Básica",
      local: "Santana do Ipanema - Alagoas",
      cargaHoraria: "40 hrs",
    },
    {
      curso: "Informática Básica",
      local: "Batalha - Alagoas",
      cargaHoraria: "40 hrs",
    },
    {
      curso: "Introdução ao Javascript",
      local: "Delmiro Gouveia",
      cargaHoraria: "40 hrs",
    },
    {
      curso: "Python",
      local: "São Miguel dos Campos",
      cargaHoraria: "40 hrs",
    },
    {
      curso: "Redes e Infraestrutura",
      local: "Pão de Açúcar",
      cargaHoraria: "40 hrs",
    },
    {
      curso: "Programação com Java",
      local: "Benedito Bentes",
      cargaHoraria: "40 hrs",
    },
    {
      curso: "Power B.I",
      local: "Santana do Ipanema",
      cargaHoraria: "40 hrs",
    },
    {
      curso: "Informática Básica",
      local: "Batalha",
      cargaHoraria: "30 hrs",
    },
    {
      curso: "Intensivão Python e C",
      local: "Benedito Bentes",
      cargaHoraria: "30 hrs",
    },
  ];

  return (
    <Container>
      {!signed && <MainHeader />}
      {turmas ? (
        <>
          <Logo>
            <img src={logo} className="img" alt="Oxe-tech_Lab" />
            <p className="subtitulo">Turmas abertas</p>
          </Logo>
          <div className="job-cards-container">
            {courses.map((turma, index) => (
              <div className="job-card" key={index}>
                <div className="job-card-header">
                  <div className="job-logo">
                    <img src={logoOxetech} alt="logo Oxetech" />
                  </div>
                  <div className="job-buttons">
                    <NavLink
                      to={signed ? "/oxetechlab" : "/login"}
                      className="apply-button"
                    >
                      Acesse
                    </NavLink>
                  </div>
                </div>
                <div className="job-card-body">
                  <h3>{turma.curso}</h3>
                  <p>
                    Local: <strong>{turma.local}</strong>
                  </p>
                  <div className="job-details">
                    <div className="job-detail">
                      Carga horária ⏳ {turma.cargaHoraria}
                    </div>
                  </div>
                  <div className="job-footer">
                    <p>Não fique de fora, inscreva-se</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </>
      ) : (
        <div className="semTurmasDisponiveis">
          <Logo>
            <img src={logo} className="img" alt="Oxe-tech_Lab" />
            <p className="subtitulo">Não existem turmas abertas no momento.</p>
            <p className="subtitulo">
              Acompanhem nossas redes sociais para maiores informações.
            </p>
            <div className="links-sociais">
              <a href="https://www.facebook.com/secti.alagoas/">
                <IoLogoFacebook color="#b53231" size={40} />
              </a>
              <a href="https://x.com/i/flow/login?redirect_after_login=%2Fsectialagoas">
                <FaXTwitter color="#b53231" size={40} />
              </a>
              <a href="https://www.instagram.com/sectialagoas/">
                <FaInstagram color="#b53231" size={40} />
              </a>
            </div>
          </Logo>
        </div>
      )}
    </Container>
  );
}

export default OxetechLabDivulgacao;
